// import React, { useState } from "react";
// import Sidebar from "../../Components/Sidebar";
// import TopNav from "../../Components/TopNav";
// import { toast } from "react-toastify";
// import {
//   bulkUploadLocationServ,
//   bulkDownloadLocationServ,
// } from "../../services/location.services";

// function BulkUploadPage() {
//   const [formData, setFormData] = useState({
//     type: "",
//     locationType: "",
//     file: null,
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleFileChange = (e) => {
//     setFormData({ ...formData, file: e.target.files[0] });
//   };

//   const handleReset = () => {
//     setFormData({ type: "", locationType: "", file: null });
//   };

//   const handleSubmit = async () => {
//     if (!formData.type || !formData.locationType || !formData.file) {
//       toast.error("All fields are required.");
//       return;
//     }
//     const uploadForm = new FormData();
//     uploadForm.append("type", formData.type);
//     uploadForm.append("locationType", formData.locationType);
//     uploadForm.append("file", formData.file);

//     try {
//       const res = await bulkUploadLocationServ(uploadForm);
//       toast.success(res.message || "Bulk upload successful");
//       handleReset();
//     } catch (err) {
//       toast.error("Upload failed. " + (err?.response?.data?.message || ""));
//     }
//   };

//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Location Management" selectedItem="Bulk Upload" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div className="infoCard mb-4 p-4 bg-light border rounded">
//             <ul className="text-primary">
//               <li>Read and follow instructions carefully while preparing data</li>
//               <li>Download and save the sample file to reduce errors</li>
//               <li>For adding bulk locations, file should be .csv or .xlsx format</li>
//               <li className="fw-bold text-dark">
//                 Make sure you entered valid data as per instructions before proceeding
//               </li>
//             </ul>
//           </div>

//           <div className="card shadow p-4">
//             <h4 className="mb-4">Bulk Upload</h4>
//             <div className="">
//               <div className="col-md-4 mb-3">
//                 <label className="form-label fw-bold">TYPE [UPLOAD/UPDATE]</label>
//                 <select
//                   name="type"
//                   className="form-control"
//                   value={formData.type}
//                   onChange={handleChange}
//                 >
//                   <option value="">Select</option>
//                   <option value="upload">Upload</option>
//                   <option value="update">Update</option>
//                 </select>
//               </div>
//               <div className="col-md-4 mb-3">
//                 <label className="form-label fw-bold">
//                   LOCATION TYPE [STATES/CITIES]
//                 </label>
//                 <select
//                   name="locationType"
//                   className="form-control"
//                   value={formData.locationType}
//                   onChange={handleChange}
//                 >
//                   <option value="">Select</option>
//                   <option value="states">States</option>
//                   <option value="cities">Cities</option>
//                 </select>
//               </div>
//               <div className="col-md-4 mb-3">
//                 <label className="form-label fw-bold">File</label>
//                 <input
//                   type="file"
//                   accept=".xlsx,.csv,.txt"
//                   className="form-control"
//                   onChange={handleFileChange}
//                 />
//               </div>
//               <div className="col-md-12 d-flex gap-2">
//                 <button className="btn btn-warning px-4" onClick={handleReset}>
//                   Reset
//                 </button>
//                 <button className="btn btn-success px-4" onClick={handleSubmit}>
//                   Submit
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BulkUploadPage;


import React, { useState } from "react";

import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";

import { toast } from "react-toastify";

import {
  bulkUploadLocationServ,
  bulkDownloadLocationServ,
} from "../../services/location.services";

function BulkUploadPage() {
  const [btnLoader, setBtnLoader] = useState(false);

  const [formData, setFormData] = useState({
    type: "",
    locationType: "",
    file: null,
  });

  /* ─────────────────────────────────────────────
      Handlers
  ───────────────────────────────────────────── */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      file: e.target.files[0],
    });
  };

  const handleReset = () => {
    setFormData({
      type: "",
      locationType: "",
      file: null,
    });

    const fileInput =
      document.getElementById("bulk-upload-file");

    if (fileInput) {
      fileInput.value = "";
    }
  };

  /* ─────────────────────────────────────────────
      Submit
  ───────────────────────────────────────────── */
  const handleSubmit = async () => {
    if (
      !formData.type ||
      !formData.locationType ||
      !formData.file
    ) {
      toast.error("All fields are required.");
      return;
    }

    setBtnLoader(true);

    const uploadForm = new FormData();

    uploadForm.append("type", formData.type);
    uploadForm.append(
      "locationType",
      formData.locationType
    );
    uploadForm.append("file", formData.file);

    try {
      const res =
        await bulkUploadLocationServ(uploadForm);

      toast.success(
        res.message || "Bulk upload successful"
      );

      handleReset();
    } catch (err) {
      toast.error(
        "Upload failed. " +
          (err?.response?.data?.message || "")
      );
    }

    setBtnLoader(false);
  };

  return (
    <div className="bodyContainer">
      <Sidebar
        selectedMenu="Location Management"
        selectedItem="Bulk Upload"
      />

      <div className="mainContainer">
        <TopNav />

        <div className="af-page">

          {/* ───────────────── Header ───────────────── */}
          <div className="af-header">
            <div className="af-header-left">
              <div>
                <div className="af-page-title">
                  Bulk Upload Locations
                </div>

                <div className="af-breadcrumb">
                  Location Management &rsaquo;
                  <span> Bulk Upload</span>
                </div>
              </div>
            </div>

            <div className="af-header-badge">
              <i className="ti ti-upload" />
              CSV / XLSX Upload
            </div>
          </div>

          {/* ───────────────── Instructions ───────────────── */}
          <div className="af-card">
            <div className="af-section-title">
              <i className="ti ti-info-circle" />
              Upload Instructions
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "14px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    minWidth: "28px",
                    height: "28px",
                    borderRadius: "8px",
                    background: "#fdf2f1",
                    color: "#a60808",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "13px",
                    fontWeight: "700",
                  }}
                >
                  1
                </div>

                <div>
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#1c0a0a",
                      marginBottom: "4px",
                    }}
                  >
                    Prepare Valid Data
                  </div>

                  <div
                    style={{
                      fontSize: "14px",
                      color: "#777",
                      lineHeight: "1.7",
                    }}
                  >
                    Make sure your sheet contains
                    properly formatted data before
                    uploading.
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    minWidth: "28px",
                    height: "28px",
                    borderRadius: "8px",
                    background: "#fdf2f1",
                    color: "#a60808",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "13px",
                    fontWeight: "700",
                  }}
                >
                  2
                </div>

                <div>
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#1c0a0a",
                      marginBottom: "4px",
                    }}
                  >
                    Use CSV or XLSX Format
                  </div>

                  <div
                    style={{
                      fontSize: "14px",
                      color: "#777",
                      lineHeight: "1.7",
                    }}
                  >
                    Only .csv and .xlsx files are
                    supported for bulk upload.
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    minWidth: "28px",
                    height: "28px",
                    borderRadius: "8px",
                    background: "#fdf2f1",
                    color: "#a60808",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "13px",
                    fontWeight: "700",
                  }}
                >
                  3
                </div>

                <div>
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#1c0a0a",
                      marginBottom: "4px",
                    }}
                  >
                    Verify Before Submit
                  </div>

                  <div
                    style={{
                      fontSize: "14px",
                      color: "#777",
                      lineHeight: "1.7",
                    }}
                  >
                    Incorrect entries may fail during
                    upload or update invalid records.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ───────────────── Upload Form ───────────────── */}
          <div className="af-card">
            <div className="af-section-title">
              <i className="ti ti-file-upload" />
              Upload Configuration
            </div>

            <div className="af-grid af-grid-3">

              {/* Type */}
              <div className="af-field">
                <label className="af-label">
                  Upload Type
                </label>

                <select
                  name="type"
                  className="af-select"
                  value={formData.type}
                  onChange={handleChange}
                >
                  <option value="">
                    Select Upload Type
                  </option>

                  <option value="upload">
                    Upload New Data
                  </option>

                  <option value="update">
                    Update Existing Data
                  </option>
                </select>
              </div>

              {/* Location Type */}
              <div className="af-field">
                <label className="af-label">
                  Location Type
                </label>

                <select
                  name="locationType"
                  className="af-select"
                  value={formData.locationType}
                  onChange={handleChange}
                >
                  <option value="">
                    Select Location Type
                  </option>

                  <option value="states">
                    States
                  </option>

                  <option value="cities">
                    Cities
                  </option>
                </select>
              </div>

              {/* File Upload */}
              <div className="af-field">
                <label className="af-label">
                  Upload File
                </label>

                <input
                  id="bulk-upload-file"
                  type="file"
                  accept=".xlsx,.csv,.txt"
                  className="af-file-input"
                  onChange={handleFileChange}
                />

                {formData.file && (
                  <div className="af-helper">
                    Selected:
                    <span
                      style={{
                        color: "#a60808",
                        marginLeft: "6px",
                        fontWeight: 600,
                      }}
                    >
                      {formData.file.name}
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* Upload Preview Box */}
            {formData.file && (
              <div
                style={{
                  marginTop: "24px",
                  border: "1px solid #f0eded",
                  borderRadius: "14px",
                  background: "#fafafa",
                  padding: "18px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "14px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                  }}
                >
                  <div
                    style={{
                      width: "52px",
                      height: "52px",
                      borderRadius: "14px",
                      background: "#fdf2f1",
                      color: "#a60808",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "22px",
                    }}
                  >
                    <i className="ti ti-file-spreadsheet" />
                  </div>

                  <div>
                    <div
                      style={{
                        fontWeight: 700,
                        color: "#1c0a0a",
                        marginBottom: "3px",
                      }}
                    >
                      {formData.file.name}
                    </div>

                    <div
                      style={{
                        fontSize: "13px",
                        color: "#999",
                      }}
                    >
                      Ready for upload
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    background: "#eafaf1",
                    color: "#1e8449",
                    fontWeight: 700,
                    fontSize: "12px",
                    borderRadius: "999px",
                    padding: "7px 14px",
                  }}
                >
                  File Attached
                </div>
              </div>
            )}
          </div>

          {/* ───────────────── Actions ───────────────── */}
          <div
            className="af-card"
            style={{
              padding: "20px 28px",
            }}
          >
            <div className="af-actions">

              <span className="af-required-note">
                Upload may take a few seconds
                depending on file size
              </span>

              <button
                className="af-cancel-btn"
                onClick={handleReset}
              >
                <i
                  className="ti ti-refresh"
                  style={{
                    marginRight: "6px",
                  }}
                />
                Reset
              </button>

              <button
                className="af-next-btn"
                onClick={
                  !btnLoader
                    ? handleSubmit
                    : undefined
                }
                disabled={btnLoader}
              >
                {btnLoader ? (
                  <>
                    <i className="ti ti-loader-2 af-spin" />
                    Uploading...
                  </>
                ) : (
                  <>
                    Upload File
                    <i className="ti ti-upload" />
                  </>
                )}
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default BulkUploadPage;